import React from 'react';
import { ThreeDots } from 'react-loader-spinner'; // Or your preferred loader

import styles from './styles.module.css';

interface LoadingOverlayProps {
  visible: boolean;
  message?: string;
  withOverlay?: boolean;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  visible,
  message = '処理中...',
  withOverlay = true,
}) => {
  if (!visible) return null;

  const loaderContent = (
    <div className={styles.loadingContainerCenter}>
      <ThreeDots color="#00BFFF" height={80} width={80} />
      {message && (
        <p style={{ marginTop: '20px', color: withOverlay ? 'white' : '#555' }}>
          {message}
        </p>
      )}
    </div>
  );

  return withOverlay ? (
    <div className={styles.overlay}>{loaderContent}</div>
  ) : (
    loaderContent
  );
};
